import React, { useState, useContext } from "react";
import {
  Box,
  useMediaQuery,
  IconButton,
  useTheme,
  Typography,
  Tooltip,
} from "@mui/material";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";

import { ColorModeContext, tokens } from "../../../Theme";
import {
  dataGridHeaderFooterHeight,
  dataGridHeight,
  dataGridRowHeight,
} from "../../../ui-components/global/utils";

const EditDailytaskList = () => {
  const navigate = useNavigate();
  const colorMode = useContext(ColorModeContext);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const YearFlag = sessionStorage.getItem("YearFlag");
  const currentPage = parseInt(sessionStorage.getItem("currentPage")) || 0;
  const location = useLocation();
  const dispatch = useDispatch();
  const { screenName, accessID } = useParams();
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const [pageSize, setPageSize] = useState(20);
  const [page, setPage] = useState(currentPage);

  const columns = [
    { headerName: "RecordID", field: "RecordID", width: 100, hide: true },
    { headerName: "SL#", field: "SLNO", width: 100, align: "right", headerAlign: "center" },
    { headerName: "FunctionsCode", field: "FunctionsCode", width: 200 },
    { headerName: "Code", field: "Code", width: 200, hide: true },
    { headerName: "FunctionsID", field: "FunctionsID", width: 100, align: "right", hide: true },
    { headerName: "Date", field: "Date", width: 300, align: "center", hide: true },
    { headerName: "Funtions Name", field: "FuntionsName", width: 150 },
    { headerName: "Project Name", field: "ProjectName", width: 150 },
    { headerName: "Description", field: "Description", width: 150 },
    { headerName: "Status", field: "Status", width: 200 },
    { headerName: "Comments", field: "Comments", width: 100, hide: true },
    { headerName: "EmployeesID", field: "EmployeesID", width: 100, hide: true },
    { headerName: "SortOrder", field: "SortOrder", width: 100, hide: true },
    { headerName: "Disable", field: "Disable", width: 100, hide: true },
    { headerName: "ProjectID", field: "ProjectID", width: 100, hide: true },
    { headerName: "parentID", field: "parentID", width: 100, hide: true },
    { headerName: "ChildID", field: "ChildID", width: 100, hide: true },
    { headerName: "ChildName", field: "ChildName", width: 100, hide: true },
    { headerName: "ProjectCode", field: "ProjectCode", width: 100, hide: true },
    { headerName: "CheckInDate", field: "CheckInDate", width: 100, hide: true },
    { headerName: "EmployeeCode", field: "EmployeeCode", width: 100, hide: true },
    { headerName: "EmployeeName", field: "EmployeeName", width: 100, hide: true },
    { headerName: "LocationCode", field: "LocationCode", width: 100, hide: true },
    { headerName: "LocationName", field: "LocationName", width: 100, hide: true },
  ];

  const CustomToolbar = () => (
    <GridToolbarContainer sx={{ display: "flex", justifyContent: "space-between" }}>
      {broken && !rtl && (
        <IconButton onClick={toggleSidebar} sx={{ ml: 1 }}>
          <MenuOutlinedIcon />
        </IconButton>
      )}
      <Typography variant="h3">{screenName}</Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <GridToolbarQuickFilter key={accessID} />
        <GridToolbarExport
          printOptions={{ disableToolbarButton: true }}
          csvOptions={{ fileName: `${screenName}` }}
        />
        <Tooltip title="Logout">
          <IconButton onClick={() => navigate("/")} color="error">
            <LogoutOutlinedIcon />
          </IconButton>
        </Tooltip>
      </Box>
    </GridToolbarContainer>
  );

  const handlePageChange = (pageNo) => {
    setPage(pageNo);
    sessionStorage.setItem("currentPage", pageNo);
  };

  return (
    <Box m="5px">
      <Box
        padding={2}
        height={dataGridHeight}
        sx={{
          "& .MuiDataGrid-root": { border: "none" },
          "& .MuiDataGrid-cell": { borderBottom: "none" },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[800],
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[800],
            height: dataGridHeaderFooterHeight,
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .odd-row": { backgroundColor: "", color: "" },
          "& .even-row": { backgroundColor: "#d0edec", color: "" },
        }}
      >
        <DataGrid
          rows={[]}
          columns={columns}
          disableSelectionOnClick
          rowHeight={dataGridRowHeight}
          headerHeight={dataGridHeaderFooterHeight}
          pageSize={pageSize}
          page={page}
          onPageSizeChange={setPageSize}
          rowsPerPageOptions={[5, 10, 15, 20]}
          onPageChange={handlePageChange}
          components={{ Toolbar: CustomToolbar }}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0 ? "odd-row" : "even-row"
          }
        />
      </Box>
    </Box>
  );
};

export default EditDailytaskList;
